import { mdiClipboardAccountOutline } from '@mdi/js'

export default {
  title: 'Functionary',
  to: 'functionary-headmaster-list',
  icon: mdiClipboardAccountOutline,
  resource: 'FunctionaryHeadMaster',
  action: 'read',
}
